import { render, staticRenderFns } from "./broadcastTask.vue?vue&type=template&id=0b439ead&scoped=true&"
import script from "./broadcastTask.vue?vue&type=script&lang=js&"
export * from "./broadcastTask.vue?vue&type=script&lang=js&"
import style0 from "./broadcastTask.vue?vue&type=style&index=0&id=0b439ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b439ead",
  null
  
)

export default component.exports